// extracted by mini-css-extract-plugin
export default {"wrapper":"BannerCard_wrapper__ZGcaD","icon":"BannerCard_icon__BbKNV"};